import {requestUser} from '@/utils/request'

// 校验验证码是否正确
export function checkCode(data, options = {}) {
  return requestUser({
    url: `/captcha/checkCode`,
    method: 'post',
    data,
    ...options
  })
}

// 账号注销
export function cancel(data) {
  return requestUser({
    url: `/shelf/cancel`,
    method: 'post',
    data
  })
}
// 给货主添加客服群聊id
export function userAddGroupId(data) {
  return requestUser({
    url: `/shelf/addGroupId`,
    method: 'post',
    data
  })
}

// 生成绑定信息
export function generateBindInfo(data) {
  return requestUser({
    url: '/authenticator/generateBindInfo',
    method: 'post',
    data
  })
}

// 绑定
export function confirmBind(data) {
  return requestUser({
    url: '/authenticator/confirmBind',
    method: 'post',
    data
  })
}

// 查询验证器
export function authenticatorSelectOne() {
  return requestUser({
    url: '/authenticator/list',
    method: 'post'
  })
}

//  生成二维码
export function authenticatorDelete(data) {
  return requestUser({
    url: '/authenticator/delete',
    method: 'post',
    data
  })
}

//  检查当前用户是否已经绑定认证器
export function checkIsBind(data) {
  return requestUser({
    url: '/authenticator/checkIsBind',
    method: 'post',
    data
  })
}

// 查询二次认证状态
export function checkSecondAuthStatus () {
  return requestUser({
    url: '/userConfig/selectSecondAuthStatus',
    method: 'post'
  })
}

// 设为默认验证器
export function defaultSecondAuth(data) {
  return requestUser({
    url: '/userConfig/defaultSecondAuth',
    method: 'post',
    data
  })
}
// 二次验证
export function captchaReCheck(data) {
  return requestUser({
    url: '/captcha/reCheck',
    method: 'post',
    data
  })
}
// 更新手机号
export function userUpdatePhone(data) {
  return requestUser({
    url: '/seller/updatePhone',
    method: 'post',
    data
  })
}
// 更新邮箱
export function userUpdateMail(data) {
  return requestUser({
    url: '/seller/updateMail',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js